import React from "react";
import { LatestVideoHero } from "../components/home/LatestVideoHero";
import { ShortsRail } from "../components/home/ShortsRail";
import { InstagramFeed } from "../components/home/InstagramFeed";
import { ServicesOverview } from "../components/home/ServicesOverview";

export default function Landing() {
  return (
    <div style={{ background: "#FFFFFF" }} data-testid="landing">
      <LatestVideoHero />
      <ShortsRail />
      <InstagramFeed />
      <ServicesOverview />
    </div>
  );
}
